import React, { Component } from 'react';
import { Modal, Button, Form } from 'antd';
import './calculateAvailable.css';
import PropTypes from 'prop-types';
import Convert from '../../convert';
import Calculations from '../../calculations'
import InputField from '../global/InputField';
import { connect } from 'react-redux';
import Translation from '../../Translation';

/**
 * Class for available towitems calculation
 * 
 * @class CalculateAvailable
 * @extends {Component}
 */
class CalculateAvailable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            circDisabled: true,
            diameterDisabled: true,
            apiDataForTowItems: [],
            isNewTowitem: false,
            newTowItemDisplay: 'displayNone',
            isTowItemSelectionVisible: false,
            tipCircumference: 0,
            tipDiam: 0,
            tipEpd: 0,
            tipVent: 0,
            tipLength: 0,
            newDpf: 0,
            newTd: 0,
            towItemProps: {},
            towItem: {},
            preferences: {},
            delSmoke: 0,
            delTar: 0,
            delNic: 0,
            delEug: 0,
            delCo: 0,
            avlSmoke: 0,
            avlTar: 0,
            avlNic: 0,
            avlEug: 0,
            avlCo: 0
        };
    }
    componentDidMount() {
        let obj = {};
        if (this.props.preferences) {
            obj.preferences = this.props.preferences;
        }

        if (this.props.tipData) {
            obj = Object.assign({}, obj, this.props.tipData);
        }

        this.setState(obj);

    }

    /**
     * getTowItemByLot is function for returning the towitems comparing the item lot numbers
     * 
     * @param {String} itemLot
     * @memberof CalculateAvailable
     */
    getTowItemByLot = (itemlot) => {
        return this.state.towItems.find(towItem => {
            return towItem.itemlot === itemlot;
        });
    }

    /**
     * handleCircChange Converts the value of circumference to diameter 
     *
     * @param {*} e
     * @memberof CalculateAvailable
     */
    handleCircChange(e) {
        this.setState({
            tipDiam: Convert.toDiameter(e.target.value)
        });
    }
    /**
    * handleDiaChange Converts the value of diameter to circumference
    *
    * @param {*} e
    * @memberof CalculateAvailable
    */

    handleDiaChange(e) {
        this.setState({
            tipCircumference: Convert.toCircumference(e.target.value)
        });
    }
    /**
     *
     * handleTowItemSelectionCancel closes the towitem selection window
     * @memberof CalculateAvailable
     */
    handleTowItemSelectionCancel = () => {
        this.setState({
            isTowItemSelectionVisible: false
        });
    }

    /**
     * handleOk function is for performing calculation with the given values by the user and return 
     * data from child to parent
     *
     * @memberof CalculateAvailable
     */
    handleOk = (e) => {
        e.preventDefault();

        this.calculateAvailable();

        setTimeout(() => {
            if (this.props.onSelect) {
                this.props.onSelect({
                    avlSmoke: this.state.avlSmoke,
                    avlTar: this.state.avlTar,
                    avlNic: this.state.avlNic,
                    avlEug: this.state.avlEug,
                    avlCo: this.state.avlCo
                })
            }
        }, 500);

    }
    /**
     * calculateAvailable function is for performing calculation with the given values by the user
     *
     * @memberof CalculateAvailable
     */
    calculateAvailable = () => {
        var calculations = Calculations(this.state.preferences);
        let input = {
            tipcirc: parseFloat(this.state.tipCircumference),
            tipDiam: parseFloat(this.state.tipDiam),
            tipepd: parseFloat(this.state.tipEpd),
            tipvent: parseFloat(this.state.tipVent),
            tiplen: parseFloat(this.state.tipLength),
            smkdelx: parseFloat(this.state.delSmoke) || 0,
            tardelx: parseFloat(this.state.delTar) || 0,
            nicdelx: parseFloat(this.state.delNic) || 0,
            eugdelx: parseFloat(this.state.delEug) || 0,
            codelx: parseFloat(this.state.delCo) || 0,
            sre: this.state.sre || 0,
            tre: this.state.tre || 0,
            nre: this.state.nre || 0,
            ere: this.state.ere || 0
        };

        if (!this.state.isTipVentVisible) {
            input.tipvent = 0;
        }

        let avls;

        if (input.tipvent === 0) {
            avls = calculations.availablesWhenTipVentZero(input);
        } else {
            avls = calculations.availablesWhenTipVentNotZero(input);
        }

        this.setState({
            avlSmoke: parseFloat(avls.avlsmk).toFixed(1),
            avlTar: parseFloat(avls.avltar).toFixed(1),
            avlNic: parseFloat(avls.avlnic).toFixed(1),
            avlEug: parseFloat(avls.avleug).toFixed(1),
            avlCo: parseFloat(avls.avlco).toFixed(1)
        });
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }
    /**
     * handleclear clears the form and set the input field with default values
     * @param {event} e
     * @memberof CalculateAvailable
     */
    handleClear = (e) => {
        e.preventDefault();

        this.setState({
            tipCircumference: 0,
            tipDiam: 0,
            tipEpd: 0,
            tipVent: 0
        });
    }
    /**
     *
     *  handleCancel closes the calculateAvailable window
     * @memberof CalculateAvailable
     */
    handleCancel = () => {
        this.props.showCalculateAvailableScreen(false);
    }

    render() {
        return (
            <div>
                <Modal
                    visible={this.props.isCalculateAvailableVisible}
                    title={<Translation labelName="lbl_calculate_available" defaultText="Calculate Available" />}
                    footer={null}
                    width={750}
                    centered
                    onCancel={() => this.handleCancel()}
                    className="calculate-available__modal">
                    <Form onSubmit={(e) => this.handleSubmit(e)}>
                        <div className="row">
                            <div className="col-md-3">
                                <InputField
                                    type='number'
                                    label={<Translation labelName="lbl_tip_circumference" defaultText="Tip Circumference" />}
                                    units={<React.Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm"/>)</React.Fragment>}
                                    name='tipCircumference'
                                    value={this.state.tipCircumference}
                                    id='tipCircumference'
                                    min='16.5'
                                    max='25'
                                    disabled={this.state.preferences.size !== 1}
                                    errorMinMax={<Translation labelName="err_msg_min_max_value_must_between_16.5-25mm" defaultText="value must be between 16.5 - 25mm" />}
                                    onChange={(event) => this.handleChange(event)}
                                    onBlur={(event) => this.handleCircChange(event)}
                                />
                            </div>
                            <div className="col-md-3">
                                <InputField
                                    type='number'
                                    label={<Translation labelName="lbl_tip_diameter" defaultText="Tip Diameter" />}
                                    units={<React.Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm"/>)</React.Fragment>}
                                    name='tipDiam'
                                    value={this.state.tipDiam}
                                    id='tipDiam'
                                    min='5.25'
                                    max='8'
                                    className="tipdiam"
                                    disabled={this.state.preferences.size !== 2}
                                    errorMinMax={<Translation labelName="err_msg_min_max_value_must_between_5.25-8mm" defaultText="Value must be between 5.25 - 8mm" />}
                                    onChange={(event) => this.handleChange(event)}
                                    onBlur={(event) => this.handleDiaChange(event)}
                                />
                            </div>
                        </div>
                        {this.state.isTipVentVisible && <div className="row">
                            <div className="col-md-3">
                                <InputField
                                    type='number'
                                    label={<Translation labelName="lbl_cigarette_design_tip_ventilation" defaultText="Tip Ventilation" />}
                                    name='tipVent'
                                    value={this.state.isTipVentVisible ? this.state.tipVent : 0}
                                    id='tipVent'
                                    min='0'
                                    max='100'
                                    allowedZero={true}
                                    errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                    onChange={(event) => this.handleChange(event)}

                                />
                            </div>
                        </div>}
                        <div className="row">
                            <div className={this.state.preferences.kretek ? 'calculate-available-calculations isKretek' : 'calculate-available-calculations'}>
                                <ul className='calculate-available-heading'>
                                    <li><h4><Translation labelName="lbl_smoke" defaultText="Smoke"></Translation></h4></li>
                                    <li><h4><Translation labelName="lbl_tar" defaultText="Tar"></Translation></h4></li>
                                    <li><h4><Translation labelName="lbl_nicotine" defaultText="Nicotine"></Translation></h4></li>
                                    <li><h4><Translation labelName="lbl_co" defaultText="CO"></Translation></h4></li>
                                    {this.state.preferences.kretek ? <li><h4><Translation labelName="lbl_eugenol" defaultText="Eugenol"></Translation></h4></li> : ''}
                                    <li><h4></h4></li>
                                </ul>
                                <ul>
                                    <li>
                                        <InputField
                                            type='number'
                                            label=''
                                            name='delSmoke'
                                            min='0'
                                            max='100'
                                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                            value={this.state.delSmoke}
                                            id='delSmoke'
                                            onChange={(event) => this.handleChange(event)}
                                            className='cigarette-wrapper__field'
                                        />
                                    </li>
                                    <li>
                                        <InputField
                                            type='number'
                                            label=''
                                            name='delTar'
                                            min='0'
                                            max='100'
                                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                            value={this.state.delTar}
                                            id='delTar'
                                            onChange={(event) => this.handleChange(event)}
                                            className='cigarette-wrapper__field'
                                        />
                                    </li>
                                    <li>
                                        <InputField
                                            type='number'
                                            label=''
                                            name='delNic'
                                            min='0'
                                            max='100'
                                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                            value={this.state.delNic}
                                            id='delNic'
                                            onChange={(event) => this.handleChange(event)}
                                            className='cigarette-wrapper__field'
                                        />
                                    </li>
                                    <li>
                                        <InputField
                                            type='number'
                                            label=''
                                            name='delCo'
                                            min='0'
                                            max='100'
                                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                            value={this.state.delCo}
                                            id='delCo'
                                            onChange={(event) => this.handleChange(event)}
                                            className='cigarette-wrapper__field'
                                        />
                                    </li>
                                    {this.state.preferences.kretek ? <li>
                                        <InputField
                                            type='number'
                                            label=''
                                            name='delEug'
                                            min='0'
                                            max='100'
                                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                            value={this.state.delEug}
                                            id='delEug'
                                            onChange={(event) => this.handleChange(event)}
                                            className='cigarette-wrapper__field'
                                        />
                                    </li> : ''}
                                    <li>
                                        <h4><Translation labelName="lbl_delivery" defaultText="Delivery" /> (<span><Translation labelName="units_mg_cig" defaultText="mg/cig"/></span>)</h4>
                                    </li>
                                </ul>
                                <ul>
                                    <li><h4>{this.state.sre || 0}</h4></li>
                                    <li><h4>{this.state.tre || 0}</h4></li>
                                    <li><h4>{this.state.nre || 0}</h4></li>
                                    <li><h4>&nbsp;</h4></li>
                                    {this.state.preferences.kretek ? <li><h4>{this.state.ere || 0}</h4></li> : ''}
                                    <li><h4><Translation labelName="lbl_cigarette_listing_removal" defaultText="Removal Efficiency" /> (%)</h4></li>
                                </ul>
                                <ul>
                                    <li>
                                        <InputField
                                            type='number'
                                            label=''
                                            name='avlSmoke'
                                            min='0'
                                            max='100'
                                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                            value={this.state.avlSmoke}
                                            id='avlSmoke'
                                            onChange={(event) => this.handleChange(event)}
                                            className='cigarette-wrapper__field'
                                            disabled
                                        />
                                    </li>
                                    <li>
                                        <InputField
                                            type='number'
                                            label=''
                                            name='avlTar'
                                            min='0'
                                            max='100'
                                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                            value={this.state.avlTar}
                                            id='avlTar'
                                            onChange={(event) => this.handleChange(event)}
                                            className='cigarette-wrapper__field'
                                            disabled
                                        />

                                    </li>
                                    <li>
                                        <InputField
                                            type='number'
                                            label=''
                                            name='avlNic'
                                            min='0'
                                            max='100'
                                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                            value={this.state.avlNic}
                                            id='avlNic'
                                            onChange={(event) => this.handleChange(event)}
                                            className='cigarette-wrapper__field'
                                            disabled
                                        />
                                    </li>
                                    <li>
                                        <InputField
                                            type='number'
                                            label=''
                                            name='avlCo'
                                            min='0'
                                            max='100'
                                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                            value={this.state.avlCo}
                                            id='avlCo'
                                            onChange={(event) => this.handleChange(event)}
                                            className='cigarette-wrapper__field'
                                            disabled
                                        />
                                    </li>
                                    {this.state.preferences.kretek ? <li>
                                        <InputField
                                            type='number'
                                            label=''
                                            name='avlEug'
                                            min='0'
                                            max='100'
                                            errorMinMax={<Translation labelName="err_msg_min_max_value_is_not_between_0-100" defaultText="value is not between 0 - 100" />}
                                            value={this.state.avlEug}
                                            id='avlEug'
                                            onChange={(event) => this.handleChange(event)}
                                            className='cigarette-wrapper__field'
                                            disabled
                                        />
                                    </li> : ''}
                                    <li>
                                        <h4><Translation labelName="lbl_cigarette_listing_available" defaultText="Available" /> (<span><Translation labelName="units_mg_cig" defaultText="mg/cig"/></span>)</h4>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </Form>
                    <div className="row">
                        <div className="col-sm-12">
                            <Button className="btn-primary calculate-custom" onClick={this.calculateAvailable}><Translation labelName="btn_calculate" defaultText="Calculate" /></Button>
                            <a href='#' className='reset-preferences pull-right' onClick={(e) => this.handleClear(e)}><Translation labelName="btn_Reset_default" defaultText="Reset to Default" /></a>
                        </div>
                    </div>
                    <div className="select-btn">
                        <button
                            type="submit"
                            className="btn btn-default"
                            onClick={(e) => this.handleOk(e)}><Translation labelName="btn_select" defaultText="Select" /></button>
                    </div>
                </Modal>
            </div>
        );
    }
}

const DefaultCalculateAvailable = Form.create()(CalculateAvailable);
const mapStateToProps = ({ loggedUserState, towItemsState }) => ({
    preferences: loggedUserState.prefData && loggedUserState.prefData.preferences,
    itemData: towItemsState.itemData
});

export default connect(mapStateToProps, null)(DefaultCalculateAvailable);

CalculateAvailable.propTypes = {
    isCalculateAvailableVisible: PropTypes.bool,
    showCalculateAvailableScreen: PropTypes.func,
    preferences: PropTypes.object,
    tipData: PropTypes.object,
    form: PropTypes.object,
    itemData: PropTypes.array,
    onSelect: PropTypes.func
}




// WEBPACK FOOTER //
// ./src/components/CalculateAvailable/index.js